import React from 'react';
import './Webmail.css';

const Webmail = () => (
  <div className="page-container dark-red-theme">
    <h2>Webmail</h2>
    <p>Dummy content for Webmail page.</p>
  </div>
);

export default Webmail;
